import { Tooltip, withStyles } from '@material-ui/core';

const tooltipBorderColor = '#C4C4C4';

export const ReceptionRefuseeTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    fontSize: '1em',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: tooltipBorderColor,
    borderRadius: '4px',
    width: '20em',
    height: '10em',
  },
  arrow: {
    color: theme.palette.common.white,
    '&:before': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: tooltipBorderColor,
    },
  },
}))(Tooltip);

export const MiseEnRefusTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    fontSize: '1em',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: tooltipBorderColor,
    borderRadius: '4px',
    width: '20em',
    height: '7em',
  },
  arrow: {
    color: theme.palette.common.white,
    '&:before': {
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: tooltipBorderColor,
    },
  },
}))(Tooltip);
